<template>
  <div id="func-53">
    <FuncionalidadeHeader @click="backSteps()" :custom-voltar="step > 1" :titulo="headerTitle" :voltar="canBack"></FuncionalidadeHeader>
    <div>
      <div v-if="step < 6">
        <bread-crumb-steps :itens-breadcrumb="itens"/>
      </div>
      <el-row>
        <el-col :span="14">
          <component :is="component"></component>
        </el-col>
        <el-col :span="10">
        <div class="line"></div>
          <component :is="info"></component>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import StepNovo from '@/views/53/Steps/StepNovo'
import StepGrupoFamiliar from '@/views/53/Steps/StepGrupoFamiliar'
import StepConfirmarConsulta from '@/views/53/Steps/StepConfirmarConsulta'
import StepListaLocal from '@/views/53/Steps/StepListaLocal'
import StepListaPrestadores from '@/views/53/Steps/StepListaPrestadores'
import StepInfoTeleconsulta from '@/views/53/Steps/Teleconsulta/StepInfoTeleconsulta'
import StepConfirmacaoSucesso from '@/views/53/Steps/StepConfirmacaoSucesso'
import RecomendacoesConsulta from '@/views/53/InfoSteps/InfoStepConfirmacaoSucesso'
import StepConfirmacaoInstrucoes from '@/views/53/Steps/Teleconsulta/StepConfirmacaoInstrucoes'
import BreadCrumbSteps from '@/components/BreadCrumbSteps/BreadCrumbSteps'
import StepListaTipoServico from '@/views/53/Steps/StepListaTipoServico.vue'
import StepIndicarResponsavelAtendimento from '@/views/53/Steps/Teleconsulta/StepIndicarResponsavelAtendimento.vue'
import StepHorarioReservado from '@/views/53/Steps/Teleconsulta/StepHorarioReservado.vue'
import StepFiltraProfissionais from '@/views/53/Steps/StepFiltraProfissionais.vue'

export default {
  data () {
    return {
      headerTitle: 'Nova Consulta',
      defaultHeaderTitle: 'Nova Consulta',
      canBack: true
    }
  },
  components: { BreadCrumbSteps, FuncionalidadeHeader },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapState('Func53', ['idAgenda', 'nomeProfissional']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('BreadCrumbsStore', ['itens', 'currentStep']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    component () {
      return this.getComponent()
    },
    info () {
      return this.getInfo()
    },
    step () {
      return this.$route.query.step
    },
    itemBreadCrumb () {
      return this.$route.query.breadCrumbItem
    },
    ordem () {
      return this.funcionalidade.parametros.ordemLocalEspecialidades
    }
  },
  methods: {
    ...mapActions('BreadCrumbsStore', ['initializeItens', 'orderItens', 'restoreNameStep']),
    getComponent () {
      let nextStep
      if (this.idAgenda === '1') {
        switch (this.step) {
          case '1':
            this.initializeItens()
            return StepNovo
          case '2':
            this.orderItens({ ordem: this.ordem, idAgenda: this.idAgenda })
            return StepGrupoFamiliar
          case '3':
            this.ordem === 1 ? nextStep = StepFiltraProfissionais : nextStep = StepListaLocal
            return nextStep
          case '3.1':
            return StepListaTipoServico
          case '4':
            this.ordem === 1 ? nextStep = StepListaLocal : nextStep = StepFiltraProfissionais
            return nextStep
          case '4.1':
            return StepListaTipoServico
          case '5':
            this.headerTitle = this.defaultHeaderTitle
            return StepListaPrestadores
          case '6':
            this.headerTitle = 'Confirmar Consulta'
            return StepConfirmarConsulta
          case '7':
            this.headerTitle = 'Consulta agendada'
            this.canBack = false
            return StepConfirmacaoSucesso
        }
      }
      if (this.idAgenda === '2') {
        switch (this.step) {
          case '1':
            this.initializeItens()
            return StepNovo
          case '2':
            this.orderItens({ ordem: this.ordem, idAgenda: this.idAgenda })
            return StepInfoTeleconsulta
          case '3':
            return StepGrupoFamiliar
          case '4':
            return StepFiltraProfissionais
          case '4.1':
            return StepListaTipoServico
          case '5':
            this.headerTitle = this.defaultHeaderTitle
            return StepListaPrestadores
          case '6':
            this.headerTitle = 'Confirmar Consulta'
            return StepConfirmarConsulta
          case '6.1':
            this.headerTitle = 'Horário reservado'
            this.canBack = false
            return StepHorarioReservado
          case '6.2':
            this.headerTitle = 'Para qual celular o médico deve ligar?'
            this.canBack = false
            return StepIndicarResponsavelAtendimento
          case '6.3':
            this.headerTitle = 'Confirmar Consulta'
            this.canBack = true
            return StepConfirmacaoInstrucoes
          case '7':
            this.headerTitle = 'Consulta agendada'
            this.canBack = false
            return StepConfirmacaoSucesso
        }
      }
      return StepNovo
    },
    getInfo () {
      switch (this.step) {
        case '7':
          return RecomendacoesConsulta
      }
    },
    backSteps () {
      this.restoreNameStep(this.currentStep)
      if (this.step === '3.1') {
        return this.$router.replace({ query: { step: 3 } })
      }

      if (this.step === '4.1') {
        return this.$router.replace({ query: { step: 4 } })
      }

      if (this.idAgenda === '2' && this.step === '6.3') {
        return this.$router.replace({ query: { step: 6.2 } })
      }

      if (this.step === '5' && this.nomeProfissional !== null) {
        return this.$router.replace({ query: { step: 3 } })
      }

      if (this.step === '0') {
        this.$router.push({ path: '53/listagem' })
      }
      this.$router.replace({ query: { step: this.step - 1 } })
    }
  }
}
</script>
<style lang="less">
#func-53 {
  .line {
    height: 100%;
    border-right: 1px solid #EEEEEE;
    float: left;
    position: fixed;
  }
  .nova-consulta-title {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
  }
  .icon-color {
    color: var('--cor-primaria');
  }
  .center {
    text-align: center;
    margin-bottom: 10px;
    margin-top: 5px;
  }

  .small {
    font-size: 12px;
    line-height: 17px;
    display: block;
    text-align: center;
    color: #333333;
  }
  .font-color {
    color: #666666
  }
  .paragrafo {
    margin-bottom: 15px;
  }
}
</style>
